import { IconButton, Tooltip } from "@mui/material";
import { Print } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface PrintButtonProps {
  color: string;
  hide: boolean;
}
export default function PrintButton({ color, hide }: PrintButtonProps) {
  const { t } = useTranslation();
  if (hide) {
    return null;
  }
  return (
    <Tooltip title={t("print")}>
      <IconButton
        sx={{ color: color, "&:hover": { opacity: 0.9 } }}
        onClick={() => {
          window.print();
        }}
      >
        <Print />
      </IconButton>
    </Tooltip>
  );
}
